import ApiService from "../../helpers/api.helpers";

export async function getOrganizations() {
	const api = new ApiService();

	return api.get(`/users/organizations`);
}
